export const onboardMapCenter = state => state.onboard.mapCenter;
